import { tw } from './zh_tw'
import { en } from './us_en'

export const locales = {
  tw: tw,
  en: en
}
